// @ts-nocheck
import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/nextjs'

const canUseDOM = (): boolean => {
	if (typeof window === 'undefined' || !window.document || !window.document.createElement) {
		return false
	}
	return true
}

const CookieHubLoader = () => {
	const [hasLoaded, setHasLoaded] = useState(false)
	const [cookieHub, setCookieHub] = useState(undefined)

	useEffect(() => {
		const intervalId = setInterval(() => {
			if (typeof window?.cookiehub !== 'undefined' && window.cookiehub !== cookieHub) {
				setCookieHub(window.cookiehub)
			}
		}, 1000) // Check every second

		return () => clearInterval(intervalId) // Clean up on unmount
	}, [cookieHub])

	useEffect(() => {
		if (canUseDOM() && !hasLoaded && typeof cookieHub?.load === 'function') {
			const cpm = {}
			try {
				cookieHub.load(cpm)
			} catch (error) {
				// CookieHub's own script can throw (e.g. storage access blocked by the
				// browser) — catch it here so it doesn't trip the page-level ErrorBoundary.
				Sentry.captureException(error, { level: 'warning', tags: { source: 'CookieHubLoader' } })
			}
			setHasLoaded(true)
		}
	}, [hasLoaded, cookieHub]) // Rerun when `hasLoaded` or `cookieHub` changes

	return null
}

export default CookieHubLoader
